// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"f20847e1","131":"962baffe","221":"f20847e1","248":"33392d5b","469":"962baffe","703":"45786e05"}[chunkId] + ".chunk.css";
};